// extracted by mini-css-extract-plugin
module.exports = {"col-md-4":"Tabs_col-md-4__GDBsi","oTabs":"Tabs_oTabs__ouYPg","mTab":"Tabs_mTab__6p7fZ","faqsLink":"Tabs_faqsLink__tXmc2"};